import React from 'react';
import { NAVBAR_MENU_KEYS } from '../../../../i18n/constants/keys';
import {
  CompassIcon,
  HeartHandshakeIcon,
  IdCardIcon,
  SlidersHorizontalIcon,
  UserCheckIcon,
  UserRoundPlusIcon,
} from '../../../../icons/animated';
import { Permission } from '../../../../utils/helpers/permissions';
import { Features } from '../../../../utils/helpers/subscriptionEnum';
import { ISystemSettingsItem } from '../interfaces';

export const SYSTEM_SETTINGS_ITEMS: ISystemSettingsItem[] = [
  {
    id: 'users_roles',
    titleKey: NAVBAR_MENU_KEYS.systemSettings.items.usersRoles.title,
    descriptionKey: NAVBAR_MENU_KEYS.systemSettings.items.usersRoles.description,
    path: '/access-management',
    icon: <UserRoundPlusIcon size={24} color="#ffffff" />,
    gradient: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    badgeColor: '#2563eb',
    permissions: [Permission.EMPLOYEE_VIEW, Permission.USERS_VIEW],
    requiredFeature: Features.EMPLOYEE,
  },
  {
    id: 'assessment_framework',
    titleKey: NAVBAR_MENU_KEYS.systemSettings.items.assessmentFramework.title,
    descriptionKey: NAVBAR_MENU_KEYS.systemSettings.items.assessmentFramework.description,
    path: '/assessment-framework',
    icon: <CompassIcon size={24} color="#ffffff" />,
    gradient: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
    badgeColor: '#7c3aed',
    permissions: [Permission.EMPLOYEE_VIEW, Permission.ASSESSMENTS_VIEW],
    requiredFeature: Features.EMPLOYEE,
  },
  {
    id: 'organization_settings',
    titleKey: NAVBAR_MENU_KEYS.systemSettings.items.organizationSettings.title,
    descriptionKey: NAVBAR_MENU_KEYS.systemSettings.items.organizationSettings.description,
    path: '/organization-settings',
    icon: <SlidersHorizontalIcon size={24} color="#ffffff" />,
    gradient: 'linear-gradient(135deg, #0d9488, #0f766e)',
    badgeColor: '#0d9488',
    permissions: [Permission.ORGUNIT_VIEW],
  },
  {
    id: 'employee_management',
    titleKey: NAVBAR_MENU_KEYS.systemSettings.items.employeeManagement.title,
    descriptionKey: NAVBAR_MENU_KEYS.systemSettings.items.employeeManagement.description,
    path: '/employee-management',
    icon: <IdCardIcon size={24} color="#ffffff" />,
    gradient: 'linear-gradient(135deg, #059669, #047857)',
    badgeColor: '#059669',
    permissions: [Permission.EMPLOYEE_VIEW],
  },
  {
    id: 'candidate_management',
    titleKey: NAVBAR_MENU_KEYS.systemSettings.items.candidateManagement.title,
    descriptionKey: NAVBAR_MENU_KEYS.systemSettings.items.candidateManagement.description,
    path: '/candidate-management',
    icon: <UserCheckIcon size={24} color="#ffffff" />,
    gradient: 'linear-gradient(135deg, #0284c7, #0369a1)',
    badgeColor: '#0284c7',
    permissions: [Permission.CANDIDATE_VIEW],
  },
  {
    id: 'partner_management',
    titleKey: NAVBAR_MENU_KEYS.systemSettings.items.partnerManagement.title,
    descriptionKey: NAVBAR_MENU_KEYS.systemSettings.items.partnerManagement.description,
    path: '/partner-management',
    icon: <HeartHandshakeIcon size={24} color="#ffffff" />,
    gradient: 'linear-gradient(135deg, #db2777, #be185d)',
    badgeColor: '#db2777',
    permissions: [Permission.PARTNER_VIEW],
  },
];
